export const getEventData = (eventID) => {
    try {
      const data = JSON.parse(localStorage.getItem("eventData") || "{}");
      return data[eventID] || null;
    } catch (error) {
      console.error("Error reading event data from localStorage:", error);
      return null;
    }
  };
  
  export const setEventData = (eventID, payload) => {
    try {
      const current = JSON.parse(localStorage.getItem("eventData") || "{}");
      localStorage.setItem(
        "eventData",
        JSON.stringify({
          ...current,
          [eventID]: payload,
        })
      );
    } catch (error) {
      console.error("Error saving event data to localStorage:", error);
    }
  };
  
  export const getSelectedTemplateId = () => {
    try {
      return localStorage.getItem("selectedTemplateId");
    } catch (error) {
      console.error("Error reading template ID from localStorage:", error);
      return null;
    }
  };
  
  export const setSelectedTemplateId = (templateId) => {
    try {
      if (templateId) {
        localStorage.setItem("selectedTemplateId", templateId);
      } else {
        localStorage.removeItem("selectedTemplateId");
      }
    } catch (error) {
      console.error("Error saving template ID to localStorage:", error);
    }
  };
  
  export const clearSelectedTemplate = () => {
    try {
      localStorage.removeItem("selectedTemplateId");
    } catch (error) {
      console.error("Error clearing template ID from localStorage:", error);
    }
  };
  
  export const clearEventData = (eventID) => {
    try {
      const current = JSON.parse(localStorage.getItem("eventData") || "{}");
      delete current[eventID];
      localStorage.setItem("eventData", JSON.stringify(current));
    } catch (error) {
      console.error("Error clearing event data from localStorage:", error);
    }
  };
  